import { Helmet } from "react-helmet";
import imgOne from "../images/Section-2/section-two-img-one.png";
import iconOne from "../images/Section-2/icon_1.png";
import iconTwo from "../images/Section-2/icon_2.png";
import iconThree from "../images/Section-2/icon_3.png";
import iconFour from "../images/Section-2/icon_4.png";

export default function SectionTwo({ openModal }: any) {
  return (
    <div className="w-full relative overflow-hidden font-poppins bg-white py-4 px-4 md:px-10">
      <Helmet>
        <title>Why Top Doctors Trust DUMOSH</title>
        <meta
          name="description"
          content="Discover why top doctors trust DUMOSH for their digital marketing and business growth needs."
        />
        <meta
          name="keywords"
          content="digital marketing, healthcare marketing, doctor marketing, SEO, branding, advertising"
        />
        <meta property="og:title" content="Why Top Doctors Trust DUMOSH" />
        <meta
          property="og:description"
          content="Discover why top doctors trust DUMOSH for their digital marketing and business growth needs."
        />
        <meta property="og:image" content={imgOne} />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://yourwebsite.com/section-two" />

        <link rel="preload" as="image" href={imgOne} />
        <link rel="preload" as="image" href={iconOne} />
        <link rel="preload" as="image" href={iconTwo} />
        <link rel="preload" as="image" href={iconThree} />
        <link rel="preload" as="image" href={iconFour} />
      </Helmet>

      <div className="w-full bg-white font-poppins px-4 md:px-6 lg:px-8">
        {/* Top Section */}
        <div className="max-w-5xl mx-auto flex md:flex-row flex-col-reverse items-center gap-10">
          {/* Left Text */}
          <div className="md:space-y-4 space-y-2 w-full md:w-1/2">
            <h1 className="text-[#3E88FF] text-start font-bold text-3xl md:text-4xl lg:text-6xl leading-snug">
              Why <span className="block">Tele-Calling</span>
            </h1>
            <p className="text-[#1e1e1e] text-start font-bold text-base lg:text-2xl">
              is the Missing Link in Your
              <span className="block">Patient Acquisition Strategy</span>
            </p>
            <p className="text-[#58595B] text-start font-semibold text-base lg:text-xl">
              Turn Leads into Loyal Patients with
              <span className="block">Personalized, Human Connection</span>
            </p>
          </div>

          {/* Right Image */}
          <div className="w-full md:w-1/2 flex justify-center">
            <img
              src={imgOne}
              alt="Telecaller Illustration"
              className="w-full max-w-[300px] md:max-w-[350px] lg:max-w-[400px] object-contain"
            />
          </div>
        </div>

        {/* Features Section */}
        <div className="max-w-5xl mx-auto mt-12 grid grid-cols-2 gap-4 md:grid-cols-4 text-center">
          <div className="flex flex-col items-center gap-2 ">
            <img src={iconOne} alt="Icon 1" className="w-12 md:w-16 lg:w-20 object-contain" />
            <p className="text-[#58595B] font-semibold text-sm md:text-base leading-tight">
              Personalized <br /> Engagement
            </p>
          </div>
          <div className="flex flex-col items-center gap-2 ">
            <img src={iconTwo} alt="Icon 2" className="w-12 md:w-16 lg:w-20 object-contain" />
            <p className="text-[#58595B] font-semibold text-sm md:text-base leading-tight">
              Immediate <br /> Response
            </p>
          </div>
          <div className="flex flex-col items-center gap-2 ">
            <img src={iconThree} alt="Icon 3" className="w-12 md:w-16 lg:w-20 object-contain" />
            <p className="text-[#58595B] font-semibold text-sm md:text-base leading-tight">
              Higher <br /> Conversion Rates
            </p>
          </div>
          <div className="flex flex-col items-center gap-2 ">
            <img src={iconFour} alt="Icon 4" className="w-12 md:w-16 lg:w-20 object-contain" />
            <p className="text-[#58595B] font-semibold text-sm md:text-base leading-tight">
              Enhanced <br /> Patient Experience
            </p>
          </div>
        </div>
        {/* Description and CTA */}
      <div className="mt-8 text-center space-y-4">
        <p className="text-black text-sm md:text-base">
          At Dumosh, our tele-calling services are seamlessly integrated with our digital <br /> 
          marketing strategies, ensuring that no lead is left behind.
        </p>
        <button
          onClick={openModal}
          className="bg-[#E91212] text-white px-6 py-2 md:px-8 md:py-3 rounded-xl font-bold text-sm md:text-xl hover:bg-[#e34242] transition-transform duration-300 transform hover:scale-105"
        >
          Book Appointment
        </button>
      </div>
      </div>


      
    </div>
  );
}
